<template>
  <div>
    <!-- <h4 class="content-block">Pegawai Detail Right</h4> -->
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div class="title-container-pegawai">
          <!-- <img :src="countryData.flag" class="flag" /> -->
          <div class="flag-pegawai">
            <!-- <img v-bind:src="imageSrc" /> -->
          </div>
          <div>
            <div class="country-name" v-if="pegawaiResponse">
              {{ pegawaiResponse.nama }}
            </div>
            <div v-if="jobHistoryReponse">
              {{ jobHistoryReponse[0].jabatan.nama }}
              <div
                v-if="jobHistoryReponse[0].subBagian"
                style="display: inline"
              >
                - {{ jobHistoryReponse[0].subBagian.nama }}
              </div>
              <div v-if="jobHistoryReponse[0].bagian" style="display: inline">
                - {{ jobHistoryReponse[0].bagian.nama }}
              </div>
              - {{ jobHistoryReponse[0].cabang.nama }}
            </div>
          </div>
        </div>
        <br />
        <div class="title-pegawai"></div>
        <DxTabPanel
          id="tabpanel"
          v-model:selected-index="tabPanelIndex"
          :data-source="tabSource"
          :animation-enabled="true"
          item-title-template="title"
          item-template="currentTemplate"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>
          <template #tBasic>
            <div v-if="!editing && pegawaiResponse">
              <div class="table-container">
                <table class="table">
                  <tbody>
                    <tr>
                      <td>Nama</td>
                      <td class="padded-column">{{ pegawaiResponse.nama }}</td>
                      <td>Alamat</td>
                      <td>{{ pegawaiResponse.alamat }}</td>
                    </tr>
                    <tr>
                      <td>Tempat lahir</td>
                      <td class="padded-column">
                        {{ pegawaiResponse.tempat_lahir }}
                      </td>
                      <td>Tgl lahir</td>
                      <td>{{ formatTglLahir() }}</td>
                    </tr>
                    <tr>
                      <td>Telp</td>
                      <td class="padded-column">
                        {{ pegawaiResponse.telp }}
                      </td>
                      <td>Agama</td>
                      <td>
                        {{ pegawaiResponse.agama.nama }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <dx-button text="Edit" @click="startEditing" />
            </div>

            <div v-if="editing && pegawaiResponse" class="editors">
              <div class="editors-container">
                <div class="left">
                  <DxTextBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    label="Nama"
                    placeholder="Nama"
                    v-model="pegawaiResponse.nama"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxTextBox>

                  <DxTextBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    label="Tempat lahir"
                    placeholder="Tempat lahir"
                    v-model="pegawaiResponse.tempat_lahir"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxTextBox>

                  <DxTextBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    label="Telp"
                    placeholder="Telp"
                    v-model="pegawaiResponse.telp"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxTextBox>
                </div>
                <div class="right">
                  <DxTextBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    label="Alamat"
                    placeholder="Alamat"
                    v-model="pegawaiResponse.alamat"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxTextBox>
                  <DxDateBox
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    :display-format="'dd/MM/yyyy'"
                    width="100%"
                    placeholder="Tgl lahir"
                    label="Tgl lahir"
                    v-model="pegawaiResponse.tgl_lahir"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxDateBox>
                  <DxSelectBox
                    :dataSource="agamaSource"
                    valueExpr="id"
                    displayExpr="nama"
                    :searchEnabled="true"
                    searchExpr="nama"
                    search-mode="startswith"
                    :styling-mode="stylingMode"
                    :label-mode="labelMode"
                    width="100%"
                    placeholder="Agama"
                    label="Agama"
                    v-model="pegawaiResponse.agama_id"
                  >
                    <DxValidator>
                      <DxRequiredRule />
                    </DxValidator>
                  </DxSelectBox>
                </div>
              </div>
              <div class="editors-container">
                <!-- <div class="left"></div> -->
                <div class="right">
                  <div class="button-container">
                    <DxButton
                      @click="validateClick('t1', $event)"
                      text="save"
                      type="default"
                      class="validate"
                      id="button-1"
                    />
                    <DxButton
                      @click="startEditing"
                      text="cancel"
                      class="validate"
                      id="button-2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #tKeluarga>
            <!-- <div id="datagrid-container"> -->
            <!-- <div class="editors">
              <div class="editors-container">
                <div class="center"> -->
            <DxDataGrid
              id="dataGridKeluarga"
              :data-source="keluargaResponse"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="id"
              width="85%"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxToolbar>
                <DxItem name="groupPanel" />
                <DxItem location="after" template="button-template" />
                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>
              <template #button-template>
                <DxButton
                  text="Import data"
                  :width="136"
                  @click="importClick"
                />
              </template>
              <dx-column data-field="nama" caption="Nama" />
              <dx-column
                data-field="keluarga_hub_id"
                caption="Hubungan Keluarga"
              >
                <DxLookupDataGrid
                  :data-source="keluargaHubSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </dx-column>
              <DxColumn
                data-field="tempat_lahir"
                caption="Tempat Lahir"
              ></DxColumn>
              <DxColumn data-field="tgl_lahir" caption="Tgl Lahir"></DxColumn>
              <DxColumn data-field="nik" caption="NIK"></DxColumn>
              <dx-column
                data-field="perkawinan_status_id"
                caption="Status Pernikahan"
              >
                <DxLookupDataGrid
                  :data-source="perkawinanStatusSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </dx-column>

              <DxColumn
                data-field="jenis_kelamin"
                caption="Jenis Kelamin"
              ></DxColumn>
              <DxColumn data-field="" caption="Pekerjaan"></DxColumn>
              <dx-column data-field="agama_id" caption="Agama">
                <DxLookupDataGrid
                  :data-source="agamaSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </dx-column>
            </DxDataGrid>
            <!-- </div>
              </div>
            </div> -->
          </template>
          <template #tPendidikan>ini pendidikan</template>
          <template #tJobCurr>ini curr job</template>
          <template #tJobHistory>ini job history</template>
        </DxTabPanel>

        <template v-if="ts[1]"> ini t2 </template>

        <template v-if="ts[0]"> </template>
        <div class="options-pegawai">
          <div class="caption">Menu</div>
          <div class="option">
            <div class="widget-container">
              <!-- <DxList
                :data-source="tasks"
                :height="400"
                :allow-item-deleting="allowDeletion"
                :search-enabled="true"
              /> -->
              <DxTreeView
                :items="treeData"
                @item-click="changeSelectionMenu"
                selection-mode="single"
                :select-by-click="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DxSelectBox from "devextreme-vue/select-box";
// import _ from "lodash";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import notify from "devextreme/ui/notify";
// import DxList from "devextreme-vue/list";
import DxTreeView from "devextreme-vue/tree-view";
import service from "./pegawai-detail-right-data.js";
import ODataStore from "devextreme/data/odata/store";
import router from "@/router";
import { DateTime } from "luxon";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  // DxEditing,
  DxColumnFixing,
  DxSelection,
  DxExport,
  // DxButton,
  DxToolbar,
  DxLookup as DxLookupDataGrid,
  DxItem,
} from "devextreme-vue/data-grid";

// import { DxBox } from "devextreme-vue/box";
// import _ from "lodash";
function getPegawaiId() {
  // alert(router.currentRoute.value.query.id)
  return router.currentRoute.value.query.id;
}

async function fetchDataPegawai() {
  const odataStore = new ODataStore({
    type: "odata",
    url:
      "http://127.0.0.1/odata/Pegawais?$filter=id eq " +
      getPegawaiId() +
      "&$expand=agama",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({
    // filter: ["id", "=", 1],
  });

  return data[0];
}

async function fetchDataPegawaiKeluarga() {
  const odataStore = new ODataStore({
    type: "odata",
    url:
      "http://127.0.0.1/odata/Keluargas?$orderby=keluarga_hub_id asc&$filter=pegawai_id eq " +
      getPegawaiId(),
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({
    // filter: ['pegawai_id', '=', 1],
    // expand: ['bagian','cabang','golongan','sub_bagian','jabatan'],
    //menyebalkan
  });
  return data;
}

const pegawaiSource = new ODataStore({
  type: "odata",
  url: "http://127.0.0.1/odata/Pegawais",
  key: "id",
  version: 4,
  beforeSend: function (e) {
    e.headers = {
      "odata-version": "4.0",
    };
    if (e.method === "PUT") e.method = "PATCH";
  },
});
function formatDateISO(dateOri) {
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("yyyy-MM-dd");
}

function formatDateDisplay(dateOri) {
  const date = DateTime.fromJSDate(new Date(dateOri));
  return date.toFormat("dd/MM/yyyy");
}

const tabMenus = [
  {
    items: [
      { text: "Basic info", template: "tBasic" },
      { text: "data keluarga", template: "tKeluarga" },
      { text: "riwayat pendidikan", template: "tPendidikan" },
    ],
  },
  {
    items: [
      { text: "Current job", template: "tJobCurr" },
      { text: "job history", template: "tJobHistory" },
    ],
  },
];

export default {
  components: {
    DxSelectBox,
    DxTextBox,
    DxDateBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    // DxList,
    DxTreeView,
    DxTabPanel,
    // DxBox,
    DxColumn,
    DxFilterRow,
    DxPager,
    DxPaging,
    // DxEditing,
    DxColumnFixing,
    DxSelection,
    DxExport,
    // DxButton,
    DxLookupDataGrid,
    DxItem,
    DxDataGrid,
    DxToolbar,
  },
  data() {
    return {
      tabPanelIndex: 0,
      tabMenus: tabMenus,
      tabSource: tabMenus[0].items,

      currentTemplate: "tBasic",
      treeData: [
        {
          id: 1,
          text: "Data Personal",
          templateIndex: 0,
          selected: true,
        },
        {
          id: 2,
          text: "Data Pekerjaan",
          templateIndex: 1,
          selected: false,
        },
      ],
      pegawaiSource,
      fieldAgama: "agama_id",
      text1: "Baru",
      text2: "GG",
      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",
      textEditing: "Hello World",
      editing: false,
      allowDeletion: false,
      birthDate: new Date(1981, 5, 3),
      tasks: [
        "Basic info",
        "Data pekerjaan",
        "Data keluarga",
        "Riwayat pendidikan",
      ],

      text: "Olivia loves to sell. She has been selling DevAV products since 2012.",
      positions: service.getPositions(),
      states: service.getStates(),
      phoneRules: {
        X: /[02-9]/,
      },
      agamaSource: new ODataStore({
        url: "http://127.0.0.1/odata/Agamas",
        key: "id",
      }),
      pegawais: {
        nama: "coba",
        alamat: "coba",
        telp: "coba",
        tempat_lahir: "coba",
        tgl_lahir: "01/12/2023",
        agama_id: 1,
      },
      pegawaiResponse: null,
      keluargaResponse: null,
      // t1: true,
      t2: false,
      myString: "t1",
      t1: true,
      ts: [true, false],
      keluargaHubSource: new ODataStore({
        url: "http://127.0.0.1/odata/KeluargaHubs",
        key: "id",
      }),
      perkawinanStatusSource: new ODataStore({
        url: "http://127.0.0.1/odata/PerkawinanStatuses",
        key: "id",
      }),
    };
  },
  async mounted() {
    this.pegawaiResponse = await fetchDataPegawai();
    this.keluargaResponse = await fetchDataPegawaiKeluarga();
  },
  computed: {
    formattedValueGet() {
      //anggap pasti agama

      return "A";
    },
  },
  methods: {
    formatTglLahir() {
      return formatDateDisplay(this.pegawaiResponse.tgl_lahir);
    },
    formattedValueGetA(arr) {
      console.log("formattedvalueget ");
      console.log(arr);
      if (arr == "agama_id")
        return this.formattedValue(this.agamaSource, this.pegawais.agama_id);
      return "A";
    },
    formattedValue(arr, id) {
      console.log(arr);
      console.log(id);
      arr
        .byKey({
          id: 1,
        })
        .then(
          (dataItem) => {
            console.log(dataItem); /* Process the "dataItem" here */
          },
          (error) => {
            console.log(error); /* Handle the "error" here */
          }
        );
      // arr.load().done((data) => {
      //   console.log(data);
      //   // Search for the value in the data array using the filter() method
      //   const foundItem = data.filter((item) => item.id === id)[0];

      //   if (foundItem) {
      //     return foundItem.nama;
      //   } else {
      //     console.log("Item not found");
      //   }
      // });
      return "SS";
    },
    startEditing() {
      if (this.editing) this.editing = false;
      else this.editing = true;
    },
    saveChanges() {
      this.editing = false;
    },
    validateClick(from, e) {
      console.log(from);
      const result = e.validationGroup.validate();
      if (result.isValid) {
        console.log(this.pegawaiResponse.id);
        console.log(this.pegawaiResponse.nama);
        // update odatastore

        pegawaiSource
          .update(
            { id: this.pegawaiResponse.id },
            {
              nama: this.pegawaiResponse.nama,
              alamat: this.pegawaiResponse.alamat,
              tempat_lahir: this.pegawaiResponse.tempat_lahir,
              tgl_lahir: formatDateISO(this.pegawaiResponse.tgl_lahir),
              telp: this.pegawaiResponse.telp,
              agama_id: this.pegawaiResponse.agama_id,
            }
          )
          .then(
            (dataObj) => {
              console.log(dataObj);
              this.editing = false;
              notify("The task was saved successfully.", "success");
            },
            (error) => {
              console.log(error);
              notify("Saving error.", "error");
            }
          );
      } else {
        notify(
          "The task was not saved. Please check if all fields are valid.",
          "error"
        );
      }
    },
    changeSelectionMenu(e) {
      console.log("MENU CLICK");
      console.log(e.itemData.templateIndex); //ini adalah treeview yang true
      // var temp = e.itemData.template;
      // console.log(this.ts[0]);

      this.tabSource = this.tabMenus[e.itemData.templateIndex].items;
      // this.ts.forEach((item, index, array) => {
      //   console.log(item);
      //   if (index == e.itemData.templateIndex) array[index] = true;
      //   else array[index] = false;
      // });

      // this.ts[0] = false;
      console.log(this.ts);

      // if (this[temp]) this[temp] = false;
      // else this[temp] = true;
    },
  },
};
</script>
<style scoped lang="scss">
.title-pegawai {
  /* padding: 0 0 20px 0; */
  /* padding-top: 70px; */
  padding-top: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
  font-size: 18px;
  font-weight: 500;
  display: block;
}

.editors {
  margin-right: 200px;
  height: 570px;
}

.editors .left {
  padding: 0 10px 0 0;
}

.editors .right {
  padding: 0 0 0 10px;
}

.editors .left,
.editors .right {
  flex-grow: 1;
}

.editors .left > *,
.editors .right > *,
.editors .center > * {
  margin-bottom: 20px;
}

.editors .center {
  padding: 0 27px 0 0;
}

.validate {
  float: right;
}

.options-pegawai {
  display: inline-block;
  padding: 15px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 200px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
  box-shadow: -5px 0 14px -8px rgba(0, 0, 0, 0.25) inset;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 20px;
}

.editors-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 27px;
}
.title-container-pegawai {
  /* min-height: 100px; */
  margin-bottom: 10px;
  padding-bottom: 2px;
}

.title-container-pegawai .country-name {
  font-size: 240%;
  font-weight: bold;
  line-height: 34px;
  margin-bottom: 10px;
}

.title-container-pegawai > div:not(.flag-pegawai) {
  /* margin-left: 204px; */
  margin-left: 150px;
}

/* ASLI */
.flag-pegawai {
  height: 100px;
  width: 106px;
  margin: 0 10px 10px 0;
  border: 1px solid #d2d3d5;
  float: left;
  border-radius: 50%;
  /* background-image: url("LOGO.png"); */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
  background-color: #fff;
}

.table {
  border-collapse: collapse;
  /* width: 100%; */
}

/* .padded-column {
  padding-right: 100px;
} */
.table td:not(.padded-column) {
  border: none;
  padding-right: 15px;
  padding-top: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
}

.padded-column {
  border: none;
  padding-right: 100px;
  padding-top: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
}

.table th {
  background-color: #f0f0f0;
  font-weight: bold;
}
.button-container {
  /* float: right; */
  /* display: flex; */
  justify-content: space-between;
}

#button-1,
#button-2 {
  margin: 0 10px;
}
#datagrid-container {
  /* width: 1200px; */
}
</style>
